import script from "./GetInvolvedView.vue?vue&type=script&setup=true&lang=js"
export * from "./GetInvolvedView.vue?vue&type=script&setup=true&lang=js"

import "./GetInvolvedView.vue?vue&type=style&index=0&id=1a52b5dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a52b5dd"]])

export default __exports__